import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./shared/ui/layout/Layout";
import {
  CheckoutPage,
  PaymentPage,
  ProfilePage,
  ReferralPage,
  TopUpPage,
  ValidationPaymentPage,
} from "@/app/pages";
import { TextGenerationPage } from "./core/chatPage/TextGenerationPage";
import { ModelSelectionPage } from "./core/chatPage/ModelSelectionPage";
import { ChatHistoryPage } from "./core/chatPage/ChatHistoryPage";
import { NotFound } from "./shared/ui/NotFound";
import { MainPage } from "./core/mainPage/MainPage";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: MainPage },
      { path: "text-generation", Component: TextGenerationPage },
      { path: "text-generation/models", Component: ModelSelectionPage },
      { path: "chat-history", Component: ChatHistoryPage },
      { path: "profile", Component: ProfilePage },
      { path: "top-up/", Component: TopUpPage },
      { path: "referral", Component: ReferralPage },
      { path: "checkout", Component: CheckoutPage },
      { path: "profile/payment", Component: PaymentPage },
      { path: "profile/payment/validation", Component: ValidationPaymentPage },
      { path: "*", Component: NotFound },
    ],
  },
]);